export default "__VITE_ASSET__BQAfo0Ro__"